var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenbig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.34pt",
    height: "20.344pt",
    viewBox: "0 0 20.34 20.344",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.84 10.172c0 2.6719-1.082 5.0898-2.832 6.8398s-4.168 2.832-6.8398 2.832c-2.668 0-5.0859-1.082-6.8359-2.832s-2.832-4.168-2.832-6.8398c0-2.6719 1.082-5.0859 2.832-6.8399 1.75-1.75 4.168-2.832 6.8359-2.832 2.6719 0 5.0898 1.082 6.8398 2.832 1.75 1.7539 2.832 4.168 2.832 6.8399h0.5c0-5.6172-4.5508-10.172-10.172-10.172-5.6172 0-10.168 4.5547-10.168 10.172 0 5.6172 4.5508 10.172 10.168 10.172 5.6211 0 10.172-4.5547 10.172-10.172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.871 292.22v-0.125h-147.28v-297.39h147.15v297.51h0.125v-0.125 0.125h0.125v-297.76h-147.65v297.89h147.65v-0.125"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenbig);
export default __webpack_public_path__ + "static/media/kitchenbig.5337d904065806e2ed99e2f896d4bc93.svg";
export { ForwardRef as ReactComponent };